<template>
  <div class="TokenComputingPower">
    <div class="page_title">
      <el-divider>
        <div class="page_title_name">算力平台</div>
      </el-divider>
    </div>
    <div class="page_content">
      <p class="page_content_text">全球领先的云主机服务提供商为您提供高性能海外CPU云主机和国内GPU云主机解决方案。</p>
      <el-button class="page_content_btn" @click="goToPlatform">进入平台</el-button>
      <img class="page_content_img" src="../../assets/qingye/computing-power-platform-homepage.png" alt="" />
    </div>
  </div>
</template>
<script>
export default {
  name: "TokenComputingPower",
  data() {
    return {
      platformUrl: "https://qyzs.aobaai.com",
    };
  },
  methods: {
    goToPlatform() {
      window.open(this.platformUrl, "_blank");
    },
  },
};
</script>
<style scoped>
.TokenComputingPower {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.page_title {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 100%;
  text-align: center;
  padding-bottom: 20px;
}
.page_title_name {
  font-weight: 600;
  font-size: 26px;
  text-align: center;
}
.page_content {
  width: 100%;
  min-height: 400px;
  display: flex;
  flex-direction: column;
}
.page_content_text {
  font-size: 16px;
  color: #666;
  line-height: 1.8;
  margin-bottom: 20px;
  text-indent: 2em;
}
.page_content_btn {
  align-self: center;
  margin-bottom: 20px;
  background-color: #2968BD;
  border-color: #2968BD;
  color: #fff;
  border-radius: 4px;
  padding: 12px 32px;
}
.page_content_btn:hover {
  background-color: #1e4f8f;
  border-color: #1e4f8f;
  color: #fff;
}
.page_content_img {
  width: 100%;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/Token/ComputingPower.vue